import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	h2 {
		font-weight: 600;
		font-size: ${CSSVars.fontSize2XL};
		text-align: center;
		margin-bottom: 30px;
		max-width: 680px;

		margin: 0 auto 30px;
		
		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			margin: 0 auto 50px;
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.card {
		max-width: 1420px;
		display: flex;
		justify-content: space-between;
		margin: 0 auto;
		background-color: ${CSSVars.gray100};
		color: ${CSSVars.gray900};
		border-radius: 10px;

		flex-direction: column;
		gap: 30px;
		padding: 30px;

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			padding: 50px;
			flex-direction: row;
		}

		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			gap: 100px;
		}
	}

	.list {
		display: flex;
		flex-direction: column;
		gap: 30px;

		.card {
			background-color: white;
			max-width: 1030px;
			width: 100%;

			.slider-text {
				.title-wrapper {
					display: flex;
					gap: 20px;
					align-items: center;
					margin-bottom: 20px;

					.step-dot {
						border-radius: 10px;
						background-color: ${CSSVars.gray300};
						display: flex;
						align-items: center;
						justify-content: center;
						font-weight: 600;
						padding: 10px 15px;
						font-size: ${CSSVars.fontSizeXL};
					}

					h5 {
						font-weight: 600;
						font-size: ${CSSVars.fontSizeXL};
					}
				}

				.install-p {
					img {
						max-width: 100%;
					}
				}
			}
		}
	}

	.text-and-dots {
		display: flex;
		gap: 30px;
		align-items: center;
		flex-direction: column;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			flex-direction: row;
			gap: 70px;
		}

		.step-dots {
			display: flex;
			gap: 20px;
			flex-direction: row;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				flex-direction: column;
			}

			.step-dot {
				border-radius: 10px;
				background-color: ${CSSVars.gray300};
				display: flex;
				align-items: center;
				justify-content: center;
				font-weight: 600;
				padding: 7px 10px;
				font-size: ${CSSVars.fontSizeMD};
				cursor: pointer;
				transition: 0.2s;
				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeLG};
					padding: 10px 13px;
				}

				&:hover {
					background-color: ${CSSVars.primary100};
				}

				&.active {
					color: ${CSSVars.white};
					background-color: ${CSSVars.primary500};
				}
			}
		}

		.slider-text {
			h5 {
				font-size: ${CSSVars.fontSizeLG};
				font-weight: 600;
				margin-bottom: 20px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			p {
				font-size: ${CSSVars.fontSizeLG};
				font-weight: 300;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}
		}
	}

	.img-container {
		background-color: ${CSSVars.gray700};
		border-radius: 10px;
		padding: 5px;
		max-width: 100%;
		position: relative;

		.zoom {
			position: absolute;
			top: 10px;
			right: 10px;
			background-color: ${CSSVars.white};
			color: ${CSSVars.gray700};
			width: 30px;
			height: 30px;
			padding: 2px;
			border-radius: 50em;
			z-index: 10;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			min-width: 440px;
			max-width: 440px;
			min-height: 300px;
			max-height: 300px;
		}

		img {
			object-fit: contain;
			position: relative !important;
		}
	}

	.link {
		border: none;
		margin: 20px auto 0;
		&:hover {
			background: none;
			color: ${CSSVars.primary700};
		}
	}

`;
